import React, { useEffect, useState } from 'react';
import {
    Box,
    Grid,
    TextField,
    FormControlLabel,
    Switch,
    Alert,
    InputAdornment,
    Typography,
    Divider,
} from '@mui/material';
import { Title as TitleIcon, Description as DescriptionIcon } from '@mui/icons-material';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useSurveyStore } from '../../surveyutilities/surveyStore';

const TextAreaBlockProperties = ({ questionId }) => {
    const { getQuestionById, updateQuestion, validateName } = useSurveyStore();
    const question = getQuestionById(questionId);
    const [nameError, setNameError] = useState('');
    const [localName, setLocalName] = useState(question?.name || '');


    const handleUpdate = (property, value) => {
        updateQuestion(questionId, { [property]: value });
    };

    useEffect(() => {
        setLocalName(question?.name || '');
    }, [question?.name]);
    if (!question) return <Typography color="error">Question not found</Typography>;

    const handleNameChange = (value) => {
        setLocalName(value);
        const validation = validateName(value, questionId);
        setNameError(validation.error);

        if (validation.isValid) {
            updateQuestion(questionId, { name: value });
        }
    };

    return (
        <Grid container spacing={2}>
            {/* Name */}
           <Grid size={{xs:12}}>
                <TextField
                    fullWidth
                    size="small"
                    label="Name (not visible to public, unique)"
                    value={localName}
                    onChange={(e) => handleNameChange(e.target.value)}
                    error={!!nameError}
                    helperText={nameError}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <VisibilityOffIcon />
                            </InputAdornment>
                        )
                    }}
                />
            </Grid>

            {/* Title */}
           <Grid size={{xs:12}}>
                <TextField
                    fullWidth
                    size="small"
                    label="Question Title"
                    value={question.title || ''}
                    onChange={(e) => handleUpdate('title', e.target.value)}
                    InputProps={{ startAdornment: <InputAdornment position="start"><TitleIcon /></InputAdornment> }}
                />
            </Grid>

            {/* Description */}
           <Grid size={{xs:12}}>
                <TextField
                    fullWidth
                    size="small"
                    label="Description"
                    multiline
                    rows={2}
                    value={question.description || ''}
                    onChange={(e) => handleUpdate('description', e.target.value)}
                    InputProps={{ startAdornment: <InputAdornment position="start"><DescriptionIcon /></InputAdornment> }}
                />
            </Grid>

            {/* Placeholder */}
           <Grid size={{xs:12}}>
                <TextField
                    fullWidth
                    size="small"
                    label="Placeholder"
                    value={question.placeholder || ''}
                    onChange={(e) => handleUpdate('placeholder', e.target.value)}
                />
            </Grid>

            {/* Rows */}
           <Grid size={{xs:12}}>
                <TextField
                    fullWidth
                    size="small"
                    type="number"
                    label="Number of Rows"
                    value={question.rows || 4}
                    onChange={(e) => handleUpdate('rows', parseInt(e.target.value) || 4)}
                    inputProps={{ min: 1, max: 20 }}
                />
            </Grid>

            {/* Max Length */}
           <Grid size={{xs:12}}>
                <TextField
                    fullWidth
                    size="small"
                    type="number"
                    label="Maximum Length (characters)"
                    value={question.maxLength || ''}
                    onChange={(e) => handleUpdate('maxLength', e.target.value ? parseInt(e.target.value) : null)}
                    helperText="Leave empty for no limit"
                />
            </Grid>

            {/* Required Switch */}
           <Grid size={{xs:12}}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={question.required || false}
                            onChange={(e) => handleUpdate('required', e.target.checked)}
                            color="primary"
                        />
                    }
                    label="Required Question"
                />
            </Grid>

            {/* Question ID */}
           <Grid size={{xs:12}}>
                <Divider sx={{ mb: 2 }} />
                <Typography variant="caption" gutterBottom>
                    ID: {questionId}
                </Typography>
            </Grid>
        </Grid>
    );
};

export default TextAreaBlockProperties;